import React, {Component} from 'react'

class DataFetcher extends Component {
    state = {
        loading: false,
        errors: false,
        data: []
    }

    loadData() {
        this.setState({loading: true})
        fetch(this.props.url)
            .then(res => res.json())
            .then(data => this.setState({ data, loading: false}))
            .catch(err => this.setState({ loading: false, error: true}));
    }

    componentDidMount() {
       this.loadData()
    }

    componentDidUpdate() {
        if (this.props.refresh) {
            this.loadData()
        }
    }

    render() {
        const {data, loading} = this.state
        return (
            this.props.children({
                ...this.props,
                ...this.state
            })
        )
    }
}

export default DataFetcher